import React from 'react';
import { useParams } from 'react-router';
import { NavLink } from 'react-router-dom';

import { Breadcrumb } from '@shared/components/bootstrap/breadcrumb';

import { AccountUsagesWidget } from '@admin/components/accounts/usages_widget';
import { InventoryGrid } from '@admin/components/inventory/grid';
import { Spinner } from '@admin/components/spinner';
import { accountURL } from '@admin/config/routes';
import { useAccountRequest } from '@admin/hooks/use_account_request';
import { useTitle } from '@admin/hooks/use_title';

const LOAD_ERROR_MESSAGE = 'Unable to load account information. Please try again.';

export const AccountInventoryShow: React.FC = () => {
  const { accountID } = useParams<{ accountID: string }>();
  const { loading, response, error } = useAccountRequest(accountID);
  const account = response?.data;

  useTitle(account ? `Acct: ${account.customer.name} - Inventory` : 'Inventory');

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        {LOAD_ERROR_MESSAGE}
      </div>
    );
  }

  if (!account) {
    return null;
  }

  return (
    <>
      <h1 className="page-header text-overflow">
        <Breadcrumb>
          <Breadcrumb.Item>
            <NavLink to="/accounts">Accounts</NavLink>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <NavLink to={accountURL({ id: account.id })}>
              #{account.number} ({account.customer.name})
            </NavLink>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Inventory</Breadcrumb.Item>
        </Breadcrumb>
      </h1>

      <p>
        <AccountUsagesWidget accountID={accountID} />
      </p>

      <InventoryGrid path={`/accounts/${accountID}/inventory.json`} accountID={Number(accountID)} />
    </>
  );
};
